import type {} from "@lit/react";
import { FormLayout as FormLayoutElement, } from "@vaadin/form-layout/vaadin-form-layout.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { FormLayoutElement, };
export type FormLayoutEventMap = Readonly<{}>;
const events = {} as FormLayoutEventMap;
export type FormLayoutProps = WebComponentProps<FormLayoutElement, FormLayoutEventMap>;
export const FormLayout = createComponent({
    elementClass: FormLayoutElement, events, react: React, tagName: "vaadin-form-layout"
});
